import { render, staticRenderFns } from "./TeacherRegister.vue?vue&type=template&id=999a954c&scoped=true&"
import script from "./TeacherRegister.vue?vue&type=script&lang=js&"
export * from "./TeacherRegister.vue?vue&type=script&lang=js&"
import style0 from "./TeacherRegister.vue?vue&type=style&index=0&id=999a954c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999a954c",
  null
  
)

export default component.exports